import { createRelationshipTypeColDef } from '../../../../../components/shared-columns/relationship-type';
import type { FirmSalesCoverageGridItemFragment } from '../graphql/__generated__';

export const relationshipTypeColDef =
  createRelationshipTypeColDef<FirmSalesCoverageGridItemFragment>({
    editable: true,
  });
